import { render, staticRenderFns } from "./TariffsTableHeader.vue?vue&type=template&id=f4d8d2ac&"
import script from "./TariffsTableHeader.vue?vue&type=script&lang=ts&"
export * from "./TariffsTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports